<template>
    <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="$rules.AddRole">
            <el-row >
                <el-col>
                     <el-form-item label="菜单名称：" prop="menuId">
                        <el-select filterable multiple v-model="form.menuIdList" placeholder="请选择菜单名称" @change="$forceUpdate()" clearable style="width:100%">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.name"
                                :value="item.id">
                             <span class="Select SelectName" style=""  :title="item.name">{{ item.name }}</span>
                             <span class="Select SelectLink" :title="item.link">{{ item.link }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="buttons">
                    <el-button @click="$emit('update:visibles',false)">取消</el-button>
                    <el-button type="primary" @click="submit()">添加</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    type: {
      type: String
    },
    row: {
      type: Object
    }
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      form: {},
      options: []
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 列表数据
    Render () {
      this.$http.get('/ucenter/menu/queryParentTopList').then((res) => {
        this.options = res.data
        if (this.options) {
          this.form.menuIdList = this.row.ids
        }
      })
    },
    // 提交
    submit () {
      var that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          var Submitform = {}
          if (!that.row.ids) {
            Submitform.modelId = that.row.id
            Submitform.menuIdList = that.form.menuIdList
          } else {
            Submitform.id = that.row.ids
            Submitform.modelId = that.row.id
            Submitform.menuIdList = that.form.menuIdList
          }
          // eslint-disable-next-line no-unused-vars
          var RequestTypeText = '操作'
          //   var RequestTypeText = that.row.ids ? '修改' : '添加'
          var RequestUrl = "'/ucenter/sys-model/assigningMenu'"
          // eslint-disable-next-line
          eval(
                `that.$http.post(${RequestUrl},${JSON.stringify(Submitform)}).then((res) => {
                    if(res.status == 200){
                        that.$message.success('${RequestTypeText}成功')
                        that.$emit('update:visibles',false)
                        that.$emit('Render')
                        sessionStorage.removeItem('dict.department.list')
                    } else {
                        that.$message.error('${RequestTypeText}失败')
                        that.$emit('update:visibles',true)
                    }
                })`
          )
        }
      })
    }
  },
  created () {
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.buttons{
    text-align: center;
}
.SelectLink{
    width: 320px;
    float: right;
    color: #8492a6;
    font-size: 12px;
    margin-right:15px;

}
.SelectName{
    width:200px;
    float:left;
}
.Select{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}
</style>
